import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import { PageLink, PageTitle } from '../../../_dashboard/layout/core';
import { NewsletterListWrapper } from './newsletter-list/NewsletterList';
import { useIntl } from 'react-intl';

const NewsletterPage = () => {
  const intl = useIntl();

  const newsletterBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'NEWSLETTER_PAGE.BREADCRUMB' }),
      path: '/apps/newsletter-management/subscribers',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='subscribers'
          element={
            <>
              <PageTitle breadcrumbs={newsletterBreadcrumbs}>
                {intl.formatMessage({ id: 'NEWSLETTER_PAGE.TITLE' })}
              </PageTitle>
              <NewsletterListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/newsletter-management/subscribers' />} />
    </Routes>
  );
};

export default NewsletterPage;
